module.exports = __webpack_public_path__ + "static/media/no_defined_outline.4ff04d61.svg";